var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "f7-page",
    { staticClass: "rowBackgroundHomepage", class: _vm.customPageClass },
    [
      _c(
        "b-container",
        { class: { customContainer: !_vm.noReduce }, attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            [
              _c("b-col", { staticClass: "p-0" }, [
                _c(
                  "div",
                  { staticClass: "panel-default" },
                  [_vm._t("pageContent")],
                  2
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }